<template>
<div class="monthly">
    <div class="monthly-left">
        <div class="monthly-title">{{$t('language.popup.runAt')}}</div>
        <time-selector @changeTime="onchangeMonthlyTime" ref="monthTime" :disable="(monthArr!=null&&monthArr.length==0)||monthlyDisable" style="margin-left:10px"></time-selector>
    </div>
    <div class="monthly-right">
        <div @mouseenter="hoverIndex=index" @mouseleave="hoverIndex=-1" @click="checkMonthDay(item)" :class="[index==31?'month-last-box':'',monthArr.includes(item)&&disable?'click-monthday-box-disable':'',monthArr.includes(item)&&!disable?'click-monthday-box':'',hoverIndex==index?'monthday-box-hover':'',monthlyDisable?'monthday-box-disable':'monthday-box']" v-for="(item, index) in monthlyData" :key="index">
            <div v-if="item!=0" :class="shakeBox">{{item}}</div>
            <div v-if="item==0" :class="shakeBox">{{$t('language.popup.lastDay')}}</div>
        </div>
    </div>
</div>
</template>

<script>
import timeSelector from "@/components/common/selector/time_selector";
export default {
    props: ['disable'],
    components: {
        "time-selector": timeSelector
    },
    data: function () {
        return {
            monthlyData: [],
            monthArr: [],
            hoverIndex: -1,
            times: '',
            monthlyDisable: false,
            shakeBox: ''
        };
    },
    created() {
        for (let i = 1; i <= 31; i++) {
            this.monthlyData.push(i);
            if (i == 31) {
                this.monthlyData.push(0);
            }
        }
    },
    methods: {
        onchangeMonthlyTime(value) {
            this.times = value;
            if (this.monthArr.length) {
                this.$parent.$parent.$parent.times = [];
                this.$parent.$parent.$parent.times.push(this.times);
                this.$parent.$parent.$parent.oldMonthlyTimes = [];
            }
        },
        checkMonthDay(item) {
            if (this.monthArr.includes(item)) {
                this.monthArr = this.monthArr.filter(function (ele) {
                    return ele != item;
                });
            } else {
                this.$parent.$parent.$parent.weeks = [];
                this.$parent.$parent.$parent.date = '';
                this.$parent.$parent.$parent.schedules.type = 'Monthly';
                if (item != this.$t('language.popup.lastDay')) {
                    this.monthArr.push(item);
                } else {
                    this.monthArr.push(0); //传入最后一天
                }
                this.$parent.$parent.$parent.times = [];
                this.$parent.$parent.$parent.times.push(this.times);
                this.clearOtherTabData();
            }
            this.$parent.$parent.$parent.days = this.monthArr;
        },
        clearOtherTabData() {
            this.$parent.$parent.$parent.$refs.daily.checkArr = [];
            this.$parent.$parent.$parent.$refs.daily.dailyTimeArr = [];
            this.$parent.$parent.$parent.$refs.daily.dailyDisableFlage = true;
            this.$parent.$parent.$parent.$refs.daily.onceDisableFlage = true;
            this.$parent.$parent.$parent.$refs.weekly.weekArr = [];
        }
    }
};
</script>

<style>
.monthly {
    width: 500px;
    /*no*/
    height: 190px;
    /*no*/
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
}

.monthly-left {
    height: 32px;
    /*no*/
    line-height: 30px;
    /*no*/
    float: left;
}

.monthly-title {
    float: left;
}

.monthly-right {
    width: 260px;
    /*no*/
    height: 190px;
    /*no*/
    margin-left: 40px;
    /*no*/
    float: left;
}

.monthday-box {
    width: 30px;
    /*no*/
    height: 30px;
    /*no*/
    border: 1px solid #cdddf5;
    /*no*/
    text-align: center;
    line-height: 30px;
    /*no*/
    float: left;
    margin: 0px 5px 5px 0px;
    /*no*/
}

.monthday-box-disable {
    width: 30px;
    /*no*/
    height: 30px;
    /*no*/
    border: 1px solid #d2d4d8;
    /*no*/
    text-align: center;
    line-height: 30px;
    /*no*/
    float: left;
    margin: 0px 5px 5px 0px;
    /*no*/
    pointer-events: none;
}

.month-last-box {
    width: 141px;
    /*no*/
    height: 32px;
    /*no*/
    float: left;
    margin: 0;
}

.monthday-box-hover {
    border: 1px solid #81abff;
    ;
    /*no*/
    background: #eef0ff;
}

.click-monthday-box {
    border: none;
    background: #7987E2;
    color: #fff;
    border: 1px solid #7987E2;
    ;
    /*no*/
}

.click-monthday-box-disable {
    border: none;
    background: #c8d1f7;
    color: #fff;
    border: 1px solid #c8d1f7;
    ;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_schedule/tab_monthly.vue